$(document).ready(function () {
	let $search = $('.search');

	if ($search.length) {
		let $input = $search.find('input');

		$input.on('focus', function () {
			$search.addClass('active');

			return false;
		});

		$(document).on('click', function (e) {
			let $container = $(e.target).closest('.vg-search');

			if ($container.attr('class') !== 'vg-search') {
				$search.removeClass('active');
				$input.blur();
			}
		});

		$(document).on('keyup', function (e) {
			if (e.key === "Escape") {
				$search.removeClass('active');
				$input.blur();
			}
		});

		let tmSearch;
		$input.on('keyup', function () {
			$('.search-input').not(this).val($(this).val());

			let $self = $(this),
				$container = $self.closest('.vg-search, .vg-search-modal'),
				$content = $container.find('.vg-search-content, .vg-search-modal-content'),
				search = $self.val();

			clearTimeout(tmSearch);

			if (search) {
				tmSearch = setTimeout(() => {
					let $btn = $container.find('button[type=submit]') ;
					$btn.addClass('loading');

					$.get('/search/lookup', {search: search}, function (data) {
						if (data.view) {
							let $result = $content.find('.vg-search-content--result');
							$result.after(data.view);
							$result.remove();
						}

						$btn.removeClass('loading');
					});
				}, 500);
			} else {

			}
		});
	}
});
